import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet";
import './Home.css';
import HomeNavbar from '../components/HomeNavbar';
import { Link } from 'react-router-dom';

// Lazy video bileşeni
const LazyVideo = ({ src, className, videoClassName }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div ref={ref} className={className}>
      {inView && (
        <video
          className={videoClassName}
          src={src}
          autoPlay
          muted
          loop
          playsInline
        />
      )}
    </div>
  );
};

const Home = () => {
  return (
    <div>
          <Helmet>
        {/* SEO Başlık */}
        <title>Ali Arda Gül Hukuk Bürosu | Ankara Avukatlık ve Hukuki Danışmanlık</title>

        {/* SEO Açıklaması */}
        <meta name="description" content="Ali Arda Gül, Ankara'da aile hukuku, ceza hukuku, ticaret hukuku ve diğer hukuki alanlarda profesyonel avukatlık ve danışmanlık hizmeti sunmaktadır." />

        {/* Anahtar Kelimeler */}
        <meta name="keywords" content="avukat, Ankara, aile hukuku, ceza hukuku, ticaret hukuku, hukuki danışmanlık, Ali Arda Gül" />

        {/* Yazar Adı */}
        <meta name="author" content="Ali Arda Gül" />

        {/* Open Graph Etiketleri */}
        <meta property="og:title" content="Ali Arda Gül Hukuk Bürosu | Ankara Avukatlık ve Hukuki Danışmanlık" />
        <meta property="og:description" content="Ankara'da hukuki sorunlarınız için Ali Arda Gül Hukuk Bürosu'ndan profesyonel yardım alın." />
        <meta property="og:image" content="https://aliardagul.av.tr/assets/logo.webp" />
        <meta property="og:url" content="https://aliardagul.av.tr" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card Etiketleri */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ali Arda Gül Hukuk Bürosu | Ankara Avukatlık ve Hukuki Danışmanlık" />
        <meta name="twitter:description" content="Ankara'da aile hukuku, ceza hukuku, ticaret hukuku ve diğer hukuki danışmanlık hizmetleri için Ali Arda Gül ile iletişime geçin." />
        <meta name="twitter:image" content="https://aliardagul.av.tr/assets/logo.webp" />
        
        {/* Canonical URL (Kopya İçerik Engelleme) */}
        <link rel="canonical" href="https://aliardagul.av.tr" />
        <script type="application/ld+json">
  {`
    {
      "@context": "https://schema.org",
      "@type": "LegalService",
      "name": "Ali Arda Gül Hukuk Bürosu",
      "url": "https://aliardagul.av.tr",
      "logo": "https://aliardagul.av.tr/assets/logo.webp",
      "image": "https://aliardagul.av.tr/assets/law-justice.webp",
      "description": "Ankara'da aile hukuku, ticaret hukuku, ceza hukuku başta olmak üzere geniş bir alanda profesyonel avukatlık hizmeti sunuyoruz.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Ankara",
        "addressCountry": "TR"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+90 555 555 5555",
        "contactType": "Customer Service"
      }
    }
  `}
</script>

      </Helmet>
    
      <HomeNavbar />

      {/* Hero Section */}
      <div className="home-container">
        <LazyVideo
          src="/assets/c.mp4"
          className=""
          videoClassName="home-background-video"
        />
        <div className="home-overlay"></div>
        <div className="home-content text-center">
          <h1>Ali Arda Gül Hukuk Bürosu</h1>
          <p className="slogan">Avukat</p>
          <Link to="/calendar" className="appointment-button">
            <span>Randevu Al</span>
            <i className="bi bi-calendar-check ms-2"></i>
          </Link>
        </div>
      </div>

      {/* Hakkımızda */}
      <div className="container mt-5">
        <h2 className="text-center mb-4">Hakkımızda</h2>
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="company-description">
              Ali Arda Gül Hukuk Bürosu, Ankara merkezli olarak bireylere ve kurumlara hukuki danışmanlık ve dava takibi hizmeti sunmaktadır.
              Müvekkillerimizin haklarını en etkin şekilde savunmayı ve hukuki süreçlerde yanlarında olmayı görev biliyoruz.
            </p>
            <p>
              Aile hukuku, ceza hukuku, iş hukuku, ticaret hukuku ve daha birçok alanda uzman kadromuz ile hukuki çözümler üretmekteyiz.
              Bize danışmadan karar vermeyin.
            </p>
          </div>
          <div className="col-md-6">
            <img src="/assets/bbb.jpg" alt="Hukuk Bürosu" className="company-image img-fluid rounded" />
          </div>
        </div>

        
        {/* Hizmetler */}
        <h2 className="text-center mt-5 mb-4">Hizmet Alanlarımız</h2>
        <div className="row">
          {[
            {
              title: "Aile Hukuku",
              video: "/assets/o.mp4",
              desc: "Boşanma, velayet, nafaka ve mal paylaşımı konularında profesyonel destek."
            },
            {
              title: "Ceza Hukuku",
              video: "/assets/a.mp4",
              desc: "Ceza davalarında etkin savunma ve hukuki danışmanlık hizmetleri."
            },
            {
              title: "Ticaret Hukuku",
              video: "/assets/ticarethukuku.mp4",
              desc: "Şirketler için sözleşme hazırlığı, uyuşmazlık çözümü ve danışmanlık."
            }
          ].map((item, i) => (
            <div className="col-md-4 mb-4" key={i}>
              <div className="custom-card">
                <LazyVideo
                  src={item.video}
                  videoClassName="card-video"
                />
                <div className="custom-card-overlay">
                  <div className="custom-card-header">
                    <h5>{item.title}</h5>
                  </div>
                  <div className="custom-card-body">
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Home;
